import i18next, { t } from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector'
import secureLocalStorage from "react-secure-storage";
import { APIStatusCode, I18NextNs, Language, TypeComponent, TypeFileBlob } from "enum/enum";
import en from "assets/Locales/en-US/translation.json";
import th from "assets/Locales/th-TH/translation.json";
import enValidation from "assets/Locales/en-US/validation.json";
import thValidation from "assets/Locales/th-TH/validation.json";
import enExampleComponent from "assets/Locales/en-US/exampleComponent.json";
import thExampleComponent from "assets/Locales/th-TH/exampleComponent.json";
import enlabelComponent from "assets/Locales/en-US/labelComponent.json";
import thlabelComponent from "assets/Locales/th-TH/labelComponent.json";
import parse from 'html-react-parser';
import axios from "axios";
import { RelativeRoutingType, useLocation, useNavigate } from "react-router-dom";
import Moment from 'moment';
import Crypto from "crypto-js";
import { keyCrypto } from "config/AppConfig";
import { useDispatch } from "react-redux";
import BlockUIActionCreators from "store/redux/BlockUI";
import DialogActionCreators from "store/redux/DialogAlert";
import No_BG from "assets/images/NoImage/no-image-available.png";
import moment from "moment";
import qs from "qs";

export const I18n = {
	envI18next: process.env.REACT_APP_I18NEXT,
	InitialI18next: () => {
		i18next
			.use(initReactI18next)
			.use(LanguageDetector)
			.use(Backend)
			.init(
				{
					ns: ["translation", "validation", "example", "caption", "labelComponent"],
					lng: I18n.GetLanguage(),
					resources: {
						th: {
							translation: th,
							validation: thValidation,
							example: thExampleComponent,
							labelComponent: thlabelComponent

						},
						en: {
							translation: en,
							validation: enValidation,
							example: enExampleComponent,
							labelComponent: enlabelComponent
						},
					},
					fallbackLng: Language.th,
					interpolation: {
						escapeValue: false
					}
				}, (err, _t) => {
					if (err) {
						return err;
					}
				});

		I18n.SetLanguage(Language.th)
	},
	GetLanguage: () => {
		let value = SecureStorage.Get(I18n.envI18next);
		if (!value) value = Language.th;
		return value;
	},
	SetLanguage: (value: string) => {
		return SecureStorage.Set(I18n.envI18next, value);
	},
	SetText: (sKey: string, sMode?: string) => {
		return t(sKey, { ns: sMode ?? I18NextNs.translation });
	}
};

export const SecureStorage = {
	Get: (name: string) => {
		return secureLocalStorage.getItem(name) as string;
	},
	Set: (name: string, value: string) => {
		return secureLocalStorage.setItem(name, value);
	},
	Remove: (name: string) => {
		return secureLocalStorage.removeItem(name);
	},
	Clear: () => {
		return secureLocalStorage.clear();
	}
};

//#region Convert Data Type
export const Convert = {
	/**
	* แปรง Date เป็น String
	* @param value string
	* @param format string
	* @returns Date string
	*/
	DateTimeToString: (value: string, format: string = "DD/MM/YYYY", local: string = "en") => {
		Moment.locale(local);
		let result = null;
		let date = Moment(value);
		if (date.isValid()) {
			if (local === "th") {
				date.add(543, "year");
			}
			result = date.format(format);
		}
		return result;
	},
	/**
	* แปรง String เป็น Date
	* @param value string "YYYY-MM-DD"
	* @returns DateTime string
	*/
	StringToDateTime: (value: string, local: string = "en") => {
		Moment.locale(local);
		let result = null;
		let date = Moment(value);
		if (date.isValid()) {
			if (local === "th") {
				date.add(543, "year");
			}
			result = date;
		}
		return result;
	},
	StringToInt: (value: string) => {
		let result = null;
		if (value) {
			result = (value + "").replace(/,/g, "");
		}
		return !isNaN(parseInt(result)) ? parseInt(result) : 0;
	},
	StringToIntOrNull: (value: string) => {
		let result = null;
		if (value) {
			result = (value + "").replace(/,/g, "");
		}
		return !isNaN(parseInt(result)) ? parseInt(result) : null;
	},
	StringToFloat: (value: string) => {
		let result = null;
		if (value) {
			result = (value + "").replace(/,/g, "");
		}
		return !isNaN(parseFloat(result)) ? parseFloat(result) : 0;
	},
	StringToFloatOrNull: (value: string) => {
		let result = null;
		if (value) {
			result = (value + "").replace(/,/g, "");
		}
		return !isNaN(parseFloat(result)) ? parseFloat(result) : null;
	},
	StringToNumber: (value: string) => {
		let result = null;
		if (value) {
			result = (value + "").replace(/,/g, "");
		}
		return !isNaN(Number(result)) ? Number(result) : 0;
	},
	StringToNumberOrNull: (value: string) => {
		let result = null;
		if (value) {
			result = (value + "").replace(/,/g, "");
		}
		return !isNaN(Number(result)) ? Number(result) : null;
	}
};

export const undefinedOrNull = (value, mode?: "string" | "number" | "bool" | "dateToString", format = "DD/MM/YYYY") => {
	if (mode === "string") {
		return value !== undefined ? value + "" : "";
	}
	else if (mode === "number") {
		return value !== undefined && value !== "" ? (+value) : null;
	} else if (mode === "bool") {
		return undefinedOrNullBoolean(value);
	} else if (mode === "dateToString") {
		let res = null;
		if (value !== undefined && value !== null && value !== "") {

			res = Convert.DateTimeToString(value, format);
		}
		return res;
	}

	return value ?? null;
}

function undefinedOrNullBoolean(value: any) {
	let res = false;
	if (value !== undefined && value !== "") {
		if ((value + "").toLowerCase() === "true") {
			res = true;
		}
	}
	return res;
}

export const insert = (arr, index, newItem) => [
	...arr.slice(0, index),
	newItem,
	...arr.slice(index),
];


export function formatNumber(num: any, digit: number) {
	if (num != null && num !== "N/A" && num !== "") {
		const numberFormatter = new Intl.NumberFormat('en-US', {
			style: 'decimal',
			minimumFractionDigits: digit,
			maximumFractionDigits: digit
		});
		let numCommas = numberFormatter.format(num);
		return numCommas
	} else {
		return num;
	}
}

const parseFloatCheckValue = (value) => {
	if (value === "" || value === null || value === undefined) {
		return null;
	}
	const floatValue = parseFloat(value);
	//not minus value
	if (isNaN(floatValue) || floatValue < 0) {
		return null;
	}
	return floatValue;
}

export const DefaultArrayEmpty = (arrData) => {
	return arrData ?? [];
};

export const DefaultNull = (val) => {
	return val ?? null;
};

export const DefaultNumber = (val) => {
	return val ?? 0;
};

export const DefaultStringEmpty = (val) => {
	return val ?? "";
};

export const ConvertToStringOrNull = (val) => {
	return val ? val.toString() : null;
};

export const ConvertDateToUnixOrNull = (val) => {
	let result = null;
	if(moment(val).isValid()) {
		result = moment(val).valueOf();
	}
	return result;
};

export const ConvertDateOrNull = (val) => {

	let result = null;
	if(moment(val).isValid()) {
		result = moment(val);
	}
	return result;
};

export const CheckConditionGetValue = (con, val1, val2) => {
	return con ? val1 : val2;
};

export const CheckLocationConditionGetValue = (con, val1, val2) => {
	const location = useLocation();
	return con ? location.state[val1] : val2;
};

export const onImageError = (e) => {
	e.target.src = No_BG;
};

export const RenderCellYear = (item) => {
	let nYear = parseInt(item.row.sYear) + 543;
	return nYear;
}

export const ConvertMonthNameTH = (nMonth: number) => {
	let sMonthNameTH = "";
	switch(nMonth)
	{
		case 1: sMonthNameTH = "มกราคม"; break;
		case 2: sMonthNameTH = "กุมภาพันธ์"; break;
		case 3: sMonthNameTH = "มีนาคม"; break;
		case 4: sMonthNameTH = "เมษายน"; break;
		case 5: sMonthNameTH = "พฤภาคม"; break;
		case 6: sMonthNameTH = "มิถุนายน"; break;
		case 7: sMonthNameTH = "กรกฎาคม"; break;
		case 8: sMonthNameTH = "สิงหาคม"; break;
		case 9: sMonthNameTH = "กันยายน"; break;
		case 10: sMonthNameTH ="ตุลาคม"; break;
		case 11: sMonthNameTH ="พฤศจิกายน"; break;
		case 12: sMonthNameTH ="ธันวาคม"; break;
	}	
	return sMonthNameTH;
};
//#endregion

//#region useNavigate
interface NavigateOptions {
	replace?: boolean;
	state?: any;
	preventScrollReset?: boolean;
	relative?: RelativeRoutingType;
};
export const RouterDOM = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const GoToPage = (sRoute: string, params?: NavigateOptions) => {
		navigate(sRoute, params);
	}
	const GetCurrentRoute = () => {
		return location.pathname.toLowerCase();
	}
	return {
		GoToPage,
		GetCurrentRoute
	};
};
export const OpenNewTab = (sUrl: string) => {
	let newWindow = window.open(sUrl, "_blank", 'noopener,noreferrer')
	if (newWindow) {
		newWindow.opener = null;
	}
};
//#endregion

//#region Axios
export const FnAxios = () => {
	// Can Hadle Popup
	const DialogFn = FnDialog();

	const Post = async (sWebMethodName: string, ParamJSON: any, fnSuccess?, fnError?, fnComplete?) => {
		const source = axios.CancelToken.source();
		const authToken = SecureStorage.Get(`${process.env.REACT_APP_JWT_KEY}`);
		const PathAPI = GetPathLocationAPI(sWebMethodName);
		let ConfigHeader = {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"Authorization": IsNullOrUndefined(authToken) ? "" : `Bearer ${authToken}`,
		};
		axios.defaults.withCredentials = true;
		axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

		await axios
			.post(PathAPI, ParamJSON, { headers: ConfigHeader, cancelToken: source.token })
			.then((res) => {
				ResultAPI(res, DialogFn, fnSuccess);
			})
			.catch((errors) => {
				if (!errors.response) {
					errors.response = { Message: errors.message };
				}
				ResultAPI(errors.response, DialogFn, fnError);
			})
			.finally(() => {
				if (fnComplete) fnComplete();
			});
	}

	const Get = async (sWebMethodName: string, ParamJSON: any, fnSuccess?, fnError?, fnComplete?) => {
		const authToken = SecureStorage.Get(`${process.env.REACT_APP_JWT_KEY}`);
		let ConfigHeader = {
			"Authorization": IsNullOrUndefined(authToken) ? "" : `Bearer ${authToken}`,
		};
		const PathAPI = GetPathLocationAPI(sWebMethodName);
		await axios
			.get(PathAPI, {
				headers: ConfigHeader,
				params: ParamJSON,
				paramsSerializer: function (params) {
					return qs.stringify(params);
				},
			}

			)
			.then((res) => {
				ResultAPI(res, DialogFn, fnSuccess);
			})
			.catch((errors) => {
				if (!errors.response) {
					errors.response = { Message: errors.message };
				}
				ResultAPI(errors.response, DialogFn, fnError);
			})
			.finally(() => {
				if (fnComplete) fnComplete();
			});
	};

	const DowloadFileSharePath = async (sPathFile: string, fileName: string, fnSuccess?, fnError?, BlockUI?: any, UnBlockUI?: any) => {
		if (BlockUI) BlockUI();

		const authToken = SecureStorage.Get(`${process.env.REACT_APP_JWT_KEY}`);
		const PathAPI = GetPathLocationAPI("UploadFile/DownloadFileInSharePath");

		await axios({
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: IsNullOrUndefined(authToken) ? "" : `Bearer ${authToken}`,
			},
			method: 'post',
			url: PathAPI,
			data: { sPathFile: sPathFile },
			responseType: "blob",
		}).then((res) => {
			let blob = new Blob([res.data], {
				type: TypeFileBlob.sharepath,
			});
			const link = document.createElement("a");
			link.target = "_blank";
			let objectUrl = URL.createObjectURL(blob);
			link.href = objectUrl;
			link.setAttribute("download", fileName);
			link.setAttribute("visibility", "hidden");
			link.click();
			link.remove();
			if (fnSuccess) fnSuccess(res);
		}).catch((errors) => {
			if (errors.response) {
				if (!errors.response) {
					errors.response = { Message: errors.message };
				}
				ResultAPI(errors.response, DialogFn, fnError);
			} else if (fnError) {
				fnError();
			}
		}).then(() => {
			if (UnBlockUI) UnBlockUI();
		});

	};

	const DowloadFileBlob = async (sWebMethodName: string, ParamJSON: any, fileName: string, fnSuccess?, fnError?, BlockUI?: any, UnBlockUI?: any) => {
		if (BlockUI) BlockUI();
	  
		let arrSplitTypeFile = fileName.split(".");
		let TypeFile = arrSplitTypeFile[arrSplitTypeFile.length - 1].toLowerCase().trim();
		let typeBlob = TypeFileBlob.pdf;
		switch (TypeFile) {
		 case "pdf":
		  typeBlob = TypeFileBlob.pdf;
		  break;
		 case "xls":
		 case "xlsx":
		  typeBlob = TypeFileBlob.excel;
		  break;
		 case "doc":
		 case "docx":
		  typeBlob = TypeFileBlob.word;
		  break;
		 case "zip":
		  typeBlob = TypeFileBlob.zip;
		  break;
		}
	  
		const authToken = SecureStorage.Get(`${process.env.REACT_APP_JWT_KEY}`);
		const PathAPI = GetPathLocationAPI(sWebMethodName);
	  
		await axios({
		 headers: {
		  "Accept": "application/json",
		  "Content-Type": "application/json",
		  "Authorization": IsNullOrUndefined(authToken) ? "" : `Bearer ${authToken}`,
		 },
		 method: 'post',
		 url: PathAPI,
		 data: ParamJSON,
		 responseType: "blob",
		}).then((res) => {
		 let blob = new Blob([res.data], {
		  type: typeBlob
		 });
		 const link = document.createElement("a");
		 link.target = "_blank";
		 let objectUrl = URL.createObjectURL(blob);
		 link.href = objectUrl;
		 link.setAttribute("download", fileName);
		 link.setAttribute("visibility", "hidden");
		 link.click();
		 link.remove();
		 if (fnSuccess) fnSuccess(res);
		}).catch((errors) => {
			if (errors.response && errors.response.data instanceof Blob) {
				const reader = new FileReader();
				reader.onload = function () {
					const text = reader.result as any;
					try {
						const errorJson = JSON.parse(text);
						ResultAPI(errorJson, DialogFn, fnError); 
					} catch (e) {
						ResultAPI(errors.response, DialogFn, fnError);
					}
				};
				reader.readAsText(errors.response.data);
			} else {
				if (fnError) fnError();
			}
		}).then(() => {
		 if (UnBlockUI) UnBlockUI();
		});
	   };

	return { Post, Get, DowloadFileBlob, DowloadFileSharePath };
};

const handleFunctionResponeData = (onFunction, response) => {
	if (onFunction) onFunction(response.data);
}

const handleFunctionResponeStatus = (onFunction, response) => {
	if (onFunction) onFunction(response.data, response.status);
}

export const ResultAPI = (response: any, DialogFn: any, onFunction: any) => {
	if (response) {
		switch (response.status) {
			case APIStatusCode.OK:
			case APIStatusCode.Warning:
			case APIStatusCode.NonAuthoritativeInformation:
				handleFunctionResponeData(onFunction, response);
				break;
			case APIStatusCode.Duplication:
				handleFunctionResponeData(onFunction, response);
				APIResponDuplicate(response, DialogFn);
				break;
			case APIStatusCode.Unauthorized:
				Unauthorize(DialogFn);
				break;
			case APIStatusCode.BadRequest:
			case APIStatusCode.NotFound:
			case APIStatusCode.InternalServerError:
				handleFunctionResponeStatus(onFunction, response)
				APIResponFail(response, DialogFn);
				break;
			case APIStatusCode.MethodNotAllowed:
				handleFunctionResponeStatus(onFunction, response)
				APIMethodFail(DialogFn);
				break;
			default:
				if (!response.data) response.data = response;
				handleFunctionResponeStatus(onFunction, response)
				break;
		}
	} else if (onFunction) onFunction(null, null);
};

export const Unauthorize = (DialogFn) => {
	DialogFn.Errors(I18n.SetText(`Message.SessionTimeOut`, I18NextNs.labelComponent), () => {
		// SecureStorage.Clear();
		SecureStorage.Remove(process.env.REACT_APP_JWT_KEY);
		setTimeout(() => {
			window.location.pathname = `${process.env.PUBLIC_URL}/`;
		}, 500);
	});
};

export const APIMethodFail = (DialogFn) => {
	let sMessage = "405 Method Not Allowed";
	DialogFn.Warning(sMessage, null, null);
};

export const APIResponDuplicate = (response, DialogFn) => {
	let sMessageDup = I18n.SetText(`Message.Duplicate`, I18NextNs.labelComponent)
	let sMessage = response.data?.sMessage ?? sMessageDup;
	DialogFn.Warning(sMessage, null, null);
};

export const APIResponFail = (response, DialogFn) => {
	let sMessageRequire = response.data?.errors?.param[0] ?? "";
	let sMessageTitle = response.data?.title ?? "";
	let sMessage = sMessageRequire ?? sMessageTitle;
	if (sMessage === "") {
		sMessage = response.data?.sMessage;
	}
	DialogFn.Warning(sMessage, null, null);
};
//#endregion

//#region Extension Type For Upload file
export const Extension = {
	Image: ["jpg", "jpeg", "png", "gif"],
	Video: ["mp4"],
	PDF: ["pdf"],
	Document: ["doc", "docx", "xls", "xlsx"],
	Word: ["doc", "docx"],
	Excel: ["xls", "xlsx"],
	PowerPoint: ["pptx", "ppt"],
	Email: ["msg"],
	Other: ["rar", "zip"],
	ImagePDF: ["jpg", "jpeg", "png", "gif", "pdf"],
	FileTicketZip: ["jpg", "jpeg", "png", "pdf", "zip"],
	FileTicket: ["jpg", "jpeg", "png", "pdf"],
	ImageDocument: [
		"jpg",
		"jpeg",
		"png",
		"gif",
		"doc",
		"docx",
		"xls",
		"xlsx",
		"pptx",
		"ppt",
		"pdf",
	],
	Image_New: ["jpg", "jpeg", "png"],
	AllType: null,
};
//#endregion

//#region Crypto
export const Encrypt = (dataEncrypt: any) => {
	let data = dataEncrypt.toString();
	let result = Crypto.AES.encrypt(data, keyCrypto).toString();
	result = result.replace(/\//g, "s14sh").replace(/\+/g, "p1u5");

	return result;
};
export const Decrypt = (dataDecrypt: any) => {
	if (dataDecrypt && dataDecrypt != null && dataDecrypt !== "null") {
		dataDecrypt = dataDecrypt.replace(/s14sh/g, "/").replace(/p1u5/g, "+");
		let bytes = Crypto.AES.decrypt(dataDecrypt, keyCrypto);
		let result = bytes.toString(Crypto.enc.Utf8);
		return result;
	} else {
		return "";
	}
};
//#endregion

//#region Dialog
export const FnDialog = () => {
	const Dispatch: any = useDispatch();
	const BlockUI = () => Dispatch(BlockUIActionCreators.BlockUI());
	const UnBlockUI = () => Dispatch(BlockUIActionCreators.UnBlockUI());

	const LoadSubmit = (Isload?) =>
		Dispatch(DialogActionCreators.LoadSubmit(Isload));

	const Submit = (msg, fn?) => {
		Dispatch(DialogActionCreators.CloseDialogSuccess());
		Dispatch(DialogActionCreators.CloseDialogError());
		Dispatch(DialogActionCreators.CloseDialogWarning());
		return Dispatch(DialogActionCreators.OpenDialogSubmit(msg, fn));
	}
	const SubmitWarning = (msg, fn?, fnC?) => {
		Dispatch(DialogActionCreators.CloseDialogSuccess());
		Dispatch(DialogActionCreators.CloseDialogError());
		Dispatch(DialogActionCreators.CloseDialogWarning());
		return Dispatch(DialogActionCreators.OpenDialogSubmitWarning(msg, fn, fnC));
	}
	const CloseSubmit = () => Dispatch(DialogActionCreators.CloseDialogSubmit());
	const CloseSubmitWarning = () =>
		Dispatch(DialogActionCreators.CloseDialogSubmitWarning());


	const Warning = (msg?, fn?, fnC?) => {
		Dispatch(DialogActionCreators.CloseDialogSuccess());
		Dispatch(DialogActionCreators.CloseDialogError());
		Dispatch(DialogActionCreators.CloseDialogWarning());
		return Dispatch(DialogActionCreators.OpenDialogWarning(msg, fn, fnC));
	}

	const Errors = (msg?, fn?, fnC?) => {
		Dispatch(DialogActionCreators.CloseDialogSuccess());
		Dispatch(DialogActionCreators.CloseDialogError());
		Dispatch(DialogActionCreators.CloseDialogWarning());
		return Dispatch(DialogActionCreators.OpenDialogError(msg, fn, fnC));
	}

	const Success = (msg?, fn?, fnC?) => {
		Dispatch(DialogActionCreators.CloseDialogSuccess());
		Dispatch(DialogActionCreators.CloseDialogError());
		Dispatch(DialogActionCreators.CloseDialogWarning());
		return Dispatch(DialogActionCreators.OpenDialogSuccess(msg, fn, fnC));
	}

	return {
		LoadSubmit,
		Success,
		Warning,
		Errors,
		Submit,
		SubmitWarning,
		CloseSubmit,
		CloseSubmitWarning,
		BlockUI,
		UnBlockUI,
	};
};
//#endregion

export const stringAvatar = (name: string) => {
	return `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
};
export function GetPathLocationAPI(sWebMethodName: string) {
	const baseUrl = process.env.REACT_APP_API_URL;
	const sPathApi = `${baseUrl}api/${sWebMethodName}`;
	const url = new URL(sPathApi, window.location.href);
	const sNewPath = url.origin + url.pathname + url.search;
	return sNewPath;
};
export const IsNullOrUndefined = (value: any) => {
	let Result = true;
	if (value) {
		Result = false;
	}
	return Result;
};
export const ParseHtml = (val: string) => {
	return val ? parse(val) : null;
};
export const OnElementFocus = (inputID: string, buttonID: string) => {
	const input = document.getElementById(inputID);
	const button = document.getElementById(buttonID);
	if (input) {
		input.addEventListener("keydown", (e) => {
			if (e.key === "Enter") {
				if (button) {
					button.click();
					return false;
				}
			}
			else if (e.key === "Backspace") return false;
		});
	}
};

//#region generate component Id
export const FnComponents = {
	GetId: (type: TypeComponent, Id: string, name: string) => {
		if (Id) {
			return Id;
		}
		else {
			let compId = `id-${name}`;
			switch (type) {
				case TypeComponent.input:
					compId = `input-${name}`;
					break;
				case TypeComponent.select:
					compId = `select-${name}`;
					break;
				case TypeComponent.switch:
					compId = `switch-${name}`;
					break;
				case TypeComponent.datePicker:
					compId = `datePicker-${name}`;
					break;
				case TypeComponent.quaterPicker:
					compId = `quaterPicker-${name}`;
					break;
				case TypeComponent.timePicker:
					compId = `timePicker-${name}`;
					break;
				case TypeComponent.checkBox:
					compId = `checkBox-${name}`;
					break;
				case TypeComponent.radio:
					compId = `radio-${name}`;
					break;
				case TypeComponent.textArea:
					compId = `textArea-${name}`;
					break;
				case TypeComponent.inputNumber:
					compId = `inputNumber-${name}`;
					break;
				case TypeComponent.autoComplete:
					compId = `autoComplete-${name}`;
					break;
				case TypeComponent.Upload:
					compId = `upload-${name}`;
					break;
			}
			return compId;
		}
	},
	GetKey: (type: TypeComponent, name: string) => {
		let compId = "";
		switch (type) {
			case TypeComponent.input:
				compId = `input-${name}`;
				break;
			case TypeComponent.select:
				compId = `select-${name}`;
				break;
			case TypeComponent.switch:
				compId = `switch-${name}`;
				break;
			case TypeComponent.datePicker:
				compId = `datePicker-${name}`;
				break;
			case TypeComponent.dateRangePicker:
				compId = `dateRangePicker-${name}`;
				break;
			case TypeComponent.timePicker:
				compId = `timePicker-${name}`;
				break;
			case TypeComponent.checkBox:
				compId = `checkBox-${name}`;
				break;
			case TypeComponent.radio:
				compId = `radio-${name}`;
				break;
			case TypeComponent.textArea:
				compId = `textArea-${name}`;
				break;
			case TypeComponent.inputNumber:
				compId = `inputNumber-${name}`;
				break;
			case TypeComponent.autoComplete:
				compId = `autoComplete-${name}`;
				break;
			case TypeComponent.Upload:
				compId = `upload-${name}`;
				break;
		}
		return compId;
	},
	GetLabel: (sLabel: string, IsDisplayLabel: boolean) => {
		return IsDisplayLabel ? sLabel : "";
	}
};


export const getMonthDifference = (startDate, endDate) => {
	return (
		endDate.getMonth() -
		startDate.getMonth() +
		12 * (endDate.getFullYear() - startDate.getFullYear())
	);
}


//#endregion
